appSocial.service('Trader', ['moment', 'SocialUtils', function (moment, SocialUtils) {
    /**
     * @name Trader
     * @class
     */
    class Trader {
        constructor(rawTrader = {}) {
            /**
             * @type {string}
             */
            this.id = rawTrader.id;
            this.init(rawTrader);
        }

        init(rawTrader = {}) {
            this.username = rawTrader.username;
            this.fullname = rawTrader.fullname;
            this.email = rawTrader.email;
            this.registrationDate = rawTrader.registration_date;
            this.avatar = rawTrader.avatar;
            this.isLeader = rawTrader.leader;
            this.country = rawTrader.country;
            this.currency = rawTrader.currency;

            this.balance = rawTrader.balance;
            this.equity = rawTrader.equity;
            this.margin = rawTrader.margin;
            this.marginFree = rawTrader.margin_free;

            this.absGain = rawTrader.abs_gain * 100;
            this.gain = rawTrader.gain * 100;

            this.bestProfit = rawTrader.best_profit;
            this.bestProfitDate = rawTrader.best_profit_date;

            this.worstProfit = rawTrader.worst_profit;
            this.worstProfitDate = rawTrader.worst_profit_date;

            this.bestPoints = rawTrader.best_points;
            this.bestPointsDate = rawTrader.best_points_date;

            this.worstPoints = rawTrader.worst_points;
            this.worstPointsDate = rawTrader.worst_points_date;

            this.deposits = rawTrader.deposits;

            this.withdrawals = rawTrader.withdrawals;
            this.profit = rawTrader.profit;

            this.avgTradeProfit = rawTrader.avg_trade_profit;
            this.avgTradeLoss = rawTrader.avg_trade_loss;

            this.drawdown = rawTrader.drawdown;

            this.avgWin = rawTrader.avg_win;
            this.avgLoss = rawTrader.avg_loss;

            this.avgTradeLength = rawTrader.avg_trade_length;

            this.longsCount = rawTrader.longs_count;
            this.longsWin = rawTrader.longs_win;

            this.shortsCount = rawTrader.shorts_count;
            this.shortsWin = rawTrader.shorts_win;

            this.volume = rawTrader.volume;

            this.maxTradeVolume = rawTrader.max_trade_volume;
            this.minTradeVolume = rawTrader.min_trade_volume;

            this.points = rawTrader.points;

            this.profitFactor = rawTrader.profit_factor;
            this.profitability = rawTrader.profitability;

            this.commissions = rawTrader.commissions;
            this.riskScore = rawTrader.risk_score;

            this.openPnl = rawTrader.open_pnl;

            this.tradesCount = rawTrader.trades_count;
            this.followersCount = rawTrader.followers_count;
            this.popularity = rawTrader.views;

            this.investedCapital = rawTrader.invested_capital;
            this.markets = rawTrader.markets;
            this.favored = rawTrader.favored;
            this.lastTradeDate = Math.abs(moment().unix() - rawTrader.last_trade_date); //Math.abs(Math.round(Date.now() - rawTrader.last_trade_date * 1000) / 1000);

            this.lifetime = moment().unix() - this.registrationDate;

            this.id && (this.gender = rawTrader.gender === 2 ? 'f' : 'm');
            this.id && (this.avatarHash = '' + (SocialUtils.hashToNum(this.id, 3) + 1));

            // visual category
            this.category = '';

            // expanded/closed leader card
            this.expanded = false;
        }

        getAvatarHash(maxImages) {
            if (this.gender) {
                return SocialUtils.hashToNum(this.id + this.gender, maxImages);
            } else {
                return SocialUtils.hashToNum(this.id, maxImages);
            }
        }

        initLeader(rawLeader) {
            this.followId = rawLeader.follow_id;
            this.followDeposit = rawLeader.deposit;
            this.followStopLoss = rawLeader.stop_loss;
            this.followBalance = rawLeader.balance;
            this.followState = rawLeader.state;

            this.followPnl = this.followBalance - this.followDeposit;
            this.followPnlPercents = rawLeader.pnl * 100;
            this.followStart = rawLeader.follow_start;
            this.followStopped = rawLeader.stopped;
            this.isFollowed = true;
        }

        updateFollowBalance(balance) {
            this.followBalance = balance;
        }

        getRisk() {
            return SocialUtils.getRisk(this.riskScore);
        }

    }

    return Trader;
}])
